import { useTranslation } from 'react-i18next'

export const LINK_PLACEHOLDER = '{{link}}'

const useOptInSmsTextField = () => {
  const { t } = useTranslation()

  return {
    label: t('common:opt_in_sms.label'),
    caption: `${t('common:opt_in_sms.caption', { link: LINK_PLACEHOLDER })} ${t('common:opt_in_sms.activation_hint')}`,
    placeholder: t('common:opt_in_sms.placeholder', { link: LINK_PLACEHOLDER }),
  }
}

export default useOptInSmsTextField
